








































































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import SgsMenu from '@/components/SgsMenu.vue';
import SgsNotification from '@/components/SgsNotification.vue';
import { env } from "@/env";
import i18n from '@/i18n';
import VueI18n from 'vue-i18n';

@Component({
  name: 'SgsLayoutComponent',
  components: {
    SgsMenu,
    SgsNotification
  }
})
export default class SgsLayoutComponent extends Vue {
  @Prop()
  public appName!: string;

  private menuExpanded: boolean;
  private icons: boolean;
  public selectedLanguage: string;
  public navigatorLanguage = navigator.language.substr(0,2);
  public languages = [...env.topLanguages!.split(',')];

  constructor() {
    super();
    this.selectedLanguage = Vue.prototype.selectedLanguage();
    this.menuExpanded = !Vue.prototype.isMobile();
    this.icons = true; // shows/hide icons on menu
  }

  private mounted() {
    this.setLanguage();
  }

  private setLanguage() {
    Vue.prototype.selectedLanguage(this.languages.find(lang => lang==this.navigatorLanguage));
    this.selectedLanguage = Vue.prototype.selectedLanguage() !== this.selectedLanguage ? this.selectedLanguage : Vue.prototype.selectedLanguage() ;
    this.$root.$i18n.locale = this.selectedLanguage;
  }

  get username(): string {
    const user = (this as any).auth.user;
    return user ? user.name : null;
  }

  get userRoles(): string {
    const user = (this as any).auth.user;
    const hasRoles =  user?.idToken?.roles?.length > 0;
    return hasRoles ? user.idToken.roles[0] : 'User';
  }

  public logout(): void {
    (this as any).auth.context.logout();
  }

}

Vue.component('sgs-layout', SgsLayoutComponent);
